var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warranty mt-4"},[_c('div',{class:{
            'input-focus-effect': true,
            'rv-valiadate-input-form': _vm.error
        }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.warranty),expression:"warranty"}],class:_vm.warranty !== '' ? 'border-primary' : '',attrs:{"type":"text","id":"inputWarranty","inputmode":"numeric"},domProps:{"value":(_vm.warranty)},on:{"focus":e => e.target.select(),"input":function($event){if($event.target.composing)return;_vm.warranty=$event.target.value}}}),_c('label',{class:{
                'mb-0': true,
                'input-on-alue': _vm.warranty !== ''
            }},[_vm._v("Bảo hành (tháng)")])]),(_vm.error)?_c('div',{staticClass:"text-danger fs-12px mt-1"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }